import React from 'react';
import { ContentList } from '../../../../_lib/components/ContentList';
import { PageToPageListItem } from './PageToPageListItem';
import { Assignment } from '../PageToPageAssignmentCard';
import { FooterLink, FooterLinkModifier } from '../../../../components/molecules/FooterLink/FooterLink';
import IUrl from '../../../../types/IUrl';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

export type PageToPageListDefaultViewProps = {
  assignments: Assignment[];
  footerLink?: IUrl;
};

export function PageToPageListDefaultView({ assignments, footerLink }: PageToPageListDefaultViewProps) {
  const { t } = useSonTranslation('PageToPage');

  return assignments && assignments.length > 0
    ? (
        <>
          <ContentList modifier="padding">
            {assignments.map(assignment => (
              <PageToPageListItem key={assignment.pageLink.url} assignment={assignment} />
            ))}
          </ContentList>
          <FooterLink
            footerButtonLabel={t('structuralPageToPageFooterLink')}
            footerLink={footerLink}
            modifier={!assignments.length ? FooterLinkModifier.NO_BORDER_TOP : undefined}
          />
        </>
      )
    : null;
}
